import styled from '@emotion/styled';
import { Typography, Button } from '@mgmresorts/mgm-ui';

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  text-align: center;
  width: 85%;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  }
`;

export const StyledBody = styled(Typography)`
  text-align: left;
  margin: ${({ theme }) => theme.semantic.SpaceComponentS}px 0 32px 0;
  color: ${({ theme }) => theme.semantic.FgContrast};
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledEnrollButtonWrapper = styled.div`
  width: 100%;
  align-self: stretch;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledFooterLinks = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
  font-size: ${({ theme }) => theme.core.FontsizeS}px;
`;

export const StyledSkipButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
